// extracted by mini-css-extract-plugin
module.exports = {"containerPageRoot":"styles_containerPageRoot__fjnaV","linkViewAll":"styles_linkViewAll__jZtJf"};